// extracted by mini-css-extract-plugin
export default {"askConsentButton":"AskConsentButton-module_askConsentButton-sEehO","label":"AskConsentButton-module_label-aW7G0"};